import { classes } from 'html-classes';
import type React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { company } from '~/company/Company';
import { Button } from '~/components/isolated/Button';
import { useHttpStatus } from '~/utils/ssrResponseStatus';

import styles from './NotFoundV3.module.scss';

type NotFoundV3Props = Omit<React.ComponentPropsWithoutRef<'div'>, 'children'>;

const NotFoundV3: React.FC<NotFoundV3Props> = ({ className, ...props }) => {
  const { t } = useTranslation();
  useHttpStatus(404);

  return (
    <div {...props} className={classes([styles.root, className])}>
      <Helmet>
        <meta
          data-react-helmet="true"
          name="robots"
          content="noindex, nofollow"
        />
      </Helmet>
      <img src={company.images.product.empty} alt="not found" />
      <h2>{t('phrases:404NotFound')}</h2>
      <Link to="/shop">
        <Button variant="primary" size="L" endIcon="chevron-3.1-right">
          {t('exploreOurCatalog')}
        </Button>
      </Link>
    </div>
  );
};

export default NotFoundV3;
